import { ReactComponent as CreditCardIcon } from '../../assets/icons/wallet.svg';
import { Stack, Typography } from '@mui/material';
import PaymentMethodSelectorButton from '../payment-form-button-selector/payment-form-button-selector.component';

const PaymentMethodSelector = ({ selected, onSelect }) => {
  const handleSelect = (method) => {
    onSelect(method);
  };

  const checkSelected = (method) => {
    return method === selected;
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ margin: { xs: '2rem 0', md: '0' } }}
    >
      <PaymentMethodSelectorButton
        selected={checkSelected('credit-card')}
        onClick={() => handleSelect('credit-card')}
      >
        <CreditCardIcon
          style={{
            width: '20px',
            height: '20px',
            color: checkSelected('credit-card') ? 'white' : 'black',
          }}
        />

        <Typography
          variant="body1"
          noWrap
          sx={{
            color: checkSelected('credit-card') ? 'white' : 'black',
            fontSize: {
              xs: '0.875rem',
              sm: '1rem',
            },

            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          Cartão de crédito
        </Typography>
      </PaymentMethodSelectorButton>
    </Stack>
  );
};

export default PaymentMethodSelector;
